import angular from 'angular';

const componentOptions = {
    bindings: {
        close: '=',
        selected: '=',
        view: '=',
        dataequalrow: '='
    },
    controllerAs: 'ibMealsBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-meals-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-bob-box-module',
    selector: 'ibMealsBox',
    inject: ['$scope', 'DatalayerUtilsService', 'AncillariesConstants'],
    required: ['']
};


export class ibMealsBox implements ng.IController {
    public selected;
    public close;
    constructor (
        private $scope: angular.IScope,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant) {

    }

    showCheckSelected = (): boolean => {
        if (this.selected > 0) {
            return true;
        }
        return false;
    };

    showButtonSelect = (): boolean => {
        if (!this.close && this.selected === 0) {
            return true;
        }
        return false;
    };

    showButtonEdit = (): boolean => {
        if (!this.close && this.selected > 0) {
            return true;
        }
        return false;
    };

    showButtonGet = (): boolean => {
        if (this.close) {
            return true;
        }
        return false;
    };

    showLabelNumMenusSingle = (): boolean => {
        if (this.selected && this.selected === 1) {
            return true;
        }
        return false;
    };

    showLabelNumMenusPlural = (): boolean => {
        if (this.selected && this.selected > 1) {
            return true;
        }
        return false;
    };
    openModal = (e: any): void => {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries(this.AncillariesConstants.DATALAYER_INFO.SPECIAL_MEALS_OPEN, this.AncillariesConstants.DATALAYER_INFO.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.ANADIR);
        this.$scope.$emit('openSpecialMealModal');
    };
}



try {
    const mod = angular.module(componentInfo.module);
    ibMealsBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibMealsBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibMealsBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibMealsBox })
    );
}